import { render, staticRenderFns } from "./WorkHeaderOpenWindowsBadge.vue?vue&type=template&id=f3d5bb68"
import script from "./WorkHeaderOpenWindowsBadge.vue?vue&type=script&lang=js"
export * from "./WorkHeaderOpenWindowsBadge.vue?vue&type=script&lang=js"
import style0 from "./WorkHeaderOpenWindowsBadge.vue?vue&type=style&index=0&id=f3d5bb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports